/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IRRPeriod = {
    SpecifiedPeriod: 'SpecifiedPeriod',
    YearToDate: 'YearToDate',
    SixMonths: 'SixMonths',
    OneYear: 'OneYear',
    ThreeYears: 'ThreeYears',
    FiveYears: 'FiveYears'
} as const;
export type IRRPeriod = typeof IRRPeriod[keyof typeof IRRPeriod];


export function IRRPeriodFromJSON(json: any): IRRPeriod {
    return IRRPeriodFromJSONTyped(json, false);
}

export function IRRPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRRPeriod {
    return json as IRRPeriod;
}

export function IRRPeriodToJSON(value?: IRRPeriod | null): any {
    return value as any;
}

